import React from 'react';
import { Row, Col, Button } from 'reactstrap';
import DebtSelectionPanel from './components/DebtSelectionPanel';
import SalesCartPanel from '../../Sales/SalesPoint/components/SalesCartPanel';
import { useNavigate } from 'react-router-dom';
import { useDebtPayment } from './hooks/useDebtPayment';
import OverlayLoader from '../../../components/Common/OverlayLoader';
import { formatCurrency } from '../../../utils/format';

/**
 * Página de Quitação de Saldo Devedor.
 * Similar ao Ponto de Venda, mas focado exclusivamente em liquidar pendências financeiras.
 */
const DebtPaymentPoint = () => {
    const navigate = useNavigate();

    const {
        memberName,
        cartItems,
        payments,
        isProcessing,
        isLoadingData,
        data,
        totals,
        handleAddPayment,
        handleRemoveItem,
        handleRemovePayment,
        handleFinalizeSale,
        saleDate, setSaleDate
    } = useDebtPayment();

    return (
        <div style={{ position: 'relative', minHeight: '400px' }}>
            {/* Cabeçalho */}
            <div className="d-flex align-items-center justify-content-between px-4 py-3 bg-dark text-white mb-4 rounded shadow-sm">
                <div className="d-flex align-items-center">
                    <Button
                        color="link"
                        className="text-white p-0 me-3"
                        onClick={() => navigate(-1)}
                    >
                        <i className="mdi mdi-arrow-left font-size-22"></i>
                    </Button>
                    <div className="avatar-xs me-3">
                        <span className="avatar-title rounded-circle bg-light text-dark font-size-16">
                            {memberName.charAt(0)}
                        </span>
                    </div>
                    <h5 className="mb-0 text-white font-size-16 text-uppercase">Pagamento de Saldo: {memberName}</h5>
                </div>

                <div className="d-flex align-items-center gap-4">
                    <div className="d-flex align-items-center">
                        <span className="badge rounded-pill bg-white text-dark font-size-12 me-2">1</span>
                        <span className="font-size-13 text-white">Quitação Aberta</span>
                    </div>
                    <div className="text-end">
                        <span className="d-block font-size-10 text-white-50">Total Final</span>
                        <h5 className="m-0 text-white font-size-16 fw-bold">
                            {formatCurrency(totals?.total || 0)}
                        </h5>
                    </div>
                </div>
            </div>

            <Row className="align-items-start g-3">
                {/* Painel de Seleção (Pagamentos - Esquerda) */}
                <Col lg={8}>
                    <DebtSelectionPanel
                        acquirers={data.acquirers}
                        suggestedValue={totals.balance > 0 ? totals.balance : 0}
                        onAddPayment={handleAddPayment}
                        saleDate={saleDate}
                        setSaleDate={setSaleDate}
                    />
                </Col>

                {/* Resumo (Direita) */}
                <Col lg={4}>
                    <SalesCartPanel
                        cartItems={cartItems}
                        payments={payments}
                        totals={totals}
                        onRemoveItem={handleRemoveItem}
                        onRemovePayment={handleRemovePayment}
                        onProceed={handleFinalizeSale}
                    />
                </Col>
            </Row>

            <OverlayLoader show={isLoadingData} label="Carregando saldo devedor..." zIndex={1050} />
            <OverlayLoader show={isProcessing} label="Processando quitação..." zIndex={1051} />
        </div>
    );
};

export default DebtPaymentPoint;
